import { OrderStatusGroup } from '@@partner:types:app'
import { gql, useQuery } from '@apollo/client'

type Query = {
  ordersByStatus: OrderStatusGroup[]
}

export const GQL_QUERY_ORDERS_BY_STATUS = gql`
  query ordersByStatus {
    ordersByStatus {
      status
      count
    }
  }
`

export const useFetchOrdersByStatus = () => useQuery<Query>(GQL_QUERY_ORDERS_BY_STATUS)